var map = {
	"./aia.svg": 3049,
	"./ant.svg": 3050,
	"./aus.svg": 3051,
	"./bah.svg": 3052,
	"./ban.svg": 3053,
	"./bar.svg": 3054,
	"./ber.svg": 3055,
	"./biz.svg": 3056,
	"./bot.svg": 3057,
	"./bru.svg": 3058,
	"./can.svg": 3059,
	"./cay.svg": 3060,
	"./cmr.svg": 3061,
	"./cok.svg": 3062,
	"./cyp.svg": 3063,
	"./dma.svg": 3064,
	"./eng.svg": 3065,
	"./fij.svg": 3066,
	"./flk.svg": 3067,
	"./gab.svg": 3068,
	"./gam.svg": 3069,
	"./ggy.svg": 3070,
	"./gha.svg": 3071,
	"./gib.svg": 3072,
	"./grn.svg": 3073,
	"./guy.svg": 3074,
	"./ind.svg": 3075,
	"./iom.svg": 3076,
	"./ivb.svg": 3077,
	"./jam.svg": 3078,
	"./jey.svg": 3079,
	"./ken.svg": 3080,
	"./kir.svg": 3081,
	"./lca.svg": 3082,
	"./les.svg": 3083,
	"./manifest.json": 877,
	"./mas.svg": 3084,
	"./maw.svg": 3085,
	"./mdv.svg": 3086,
	"./mlt.svg": 3087,
	"./moz.svg": 3088,
	"./mri.svg": 3089,
	"./msr.svg": 3090,
	"./nam.svg": 3091,
	"./nfk.svg": 3092,
	"./ngr.svg": 3093,
	"./nir.svg": 3094,
	"./niu.svg": 3095,
	"./nru.svg": 3096,
	"./nzl.svg": 3097,
	"./pak.svg": 3098,
	"./png.svg": 3099,
	"./rsa.svg": 3100,
	"./rwa.svg": 3101,
	"./sam.svg": 3102,
	"./sco.svg": 3103,
	"./sey.svg": 3104,
	"./sgp.svg": 3105,
	"./shn.svg": 3106,
	"./skn.svg": 3107,
	"./sle.svg": 3108,
	"./sol.svg": 3109,
	"./sri.svg": 3110,
	"./svg-country.svg": 3111,
	"./swz.svg": 3112,
	"./tan.svg": 3113,
	"./tca.svg": 3114,
	"./tga.svg": 3115,
	"./tog.svg": 3116,
	"./tto.svg": 3117,
	"./tuv.svg": 3118,
	"./uga.svg": 3119,
	"./van.svg": 3120,
	"./wal.svg": 3121,
	"./zam.svg": 3122
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3048;